/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { closeModal, switchModal, speak } from '../../actions';
import X from '../../assets/login/x.svg';

const OnboardingInitial = (props) => {
  return (
    <div className="modal onboarding-background">
      <img onClick={props.closeModal} className="x-icon" src={X} alt="x" />
      <h2 className={`${props.speechEnabled && 'bolded'} onboarding-header`} onClick={props.speak}>
        Check this out!
      </h2>
      <div role="button" tabIndex={0} onClick={props.speak} className="onboarding-initial-body">
        <div className={`${props.speechEnabled && 'bolded'}`}>
          <p className="color" onClick={props.speak}>Now that we&apos;re set, here is a little tutorial to help you navigate through the surveys, understand your results, and access your dashboard!</p>
        </div>
        <input type="button" value="Next" className="sign-in-button" onClick={() => props.switchModal('Onboarding1')} />
        <p onClick={props.closeModal} className="skip">Skip</p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, { closeModal, switchModal, speak })(OnboardingInitial);
